module.exports = __webpack_public_path__ + "img/bubbles.70b49b10.svg";